var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "pop-add-tips",
      attrs: {
        title: "提示",
        visible: _vm.popAddOrderTips,
        "append-to-body": true,
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.popAddOrderTips = $event
        },
      },
    },
    [
      _c("div", { staticClass: "order-title danger" }, [
        _vm._v(
          "该客户存在等待您关联开单的记录，请确认是否不按关联开单进行添单！"
        ),
      ]),
      _c(
        "el-checkbox-group",
        {
          staticClass: "order-checkbox",
          model: {
            value: _vm.hasAddOrderids,
            callback: function ($$v) {
              _vm.hasAddOrderids = $$v
            },
            expression: "hasAddOrderids",
          },
        },
        _vm._l(_vm.hasAddOrderidsList, function (item, index) {
          return _c(
            "el-checkbox",
            { key: index, attrs: { label: item.resourceId } },
            [
              _vm._v("不再提示，订单编号：" + _vm._s(item.orderNo) + " "),
              _c(
                "sup",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.afterSale === 1,
                      expression: "item.afterSale===1",
                    },
                  ],
                  staticClass: "hasSale",
                },
                [_vm._v("售")]
              ),
            ]
          )
        }),
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.popAddOrderTips = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.closeAddOrderTips },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }